import { useState } from 'react';
import { useSelector } from 'react-redux';
import axios from 'axios';
import { API_BASE_URL } from '../../constants';
import { Btn, ErrorState } from '../ForBrands/ui/BrandUI';

/**
 * Stripe Checkout button (V2 style). Redirects to the Stripe-hosted
 * checkout page, or reloads when the backend applied a prorated plan change.
 */
const StripeCheckout = ({ tier, interval = 'monthly', label = 'Start free trial', variant = 'primary', className = 'w-full' }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const auth = useSelector((state) => state.auth);

  const handleCheckout = async () => {
    setLoading(true);
    setError(null);
    try {
      const config = {
        headers: {
          Authorization: `Bearer ${auth.token}`,
          'Content-Type': 'application/json',
        },
      };
      const response = await axios.post(`${API_BASE_URL}/stripe/create-checkout-session/`, { tier, interval }, config);
      if (response.data.upgraded) {
        // Plan was changed with proration: reload to reflect the new state.
        window.location.reload();
      } else {
        window.location.href = response.data.checkoutUrl;
      }
    } catch (err) {
      // The server's sentence first: a covered athlete reads "Premium is
      // included with your team's plan." rather than the bare code.
      setError(err.response?.data?.message || err.response?.data?.error || 'Could not start checkout.');
      setLoading(false);
    }
  };

  return (
    <div className="flex flex-col gap-3">
      {error && <ErrorState>{error}</ErrorState>}
      <Btn variant={variant} onClick={handleCheckout} disabled={loading} className={className}>
        {loading ? 'Opening checkout...' : label}
      </Btn>
    </div>
  );
};

export default StripeCheckout;
